export async function uploadFile(api, pid, file, onProgress) {
  const { data: init } = await api.post(`/projects/${pid}/files/init`, { filename: file.name, size: file.size });
  for (let i = 0; i < init.chunks; i++) {
    const blob = file.slice(i * init.chunk_size, (i + 1) * init.chunk_size);
    await api.put(`/projects/${pid}/files/${init.id}/chunk?index=${i}`, blob, { headers: { "Content-Type": "application/octet-stream" } });
    onProgress?.(Math.round(((i + 1) / init.chunks) * 100));
  }
  return (await api.post(`/projects/${pid}/files/${init.id}/complete`)).data;
}

export const FILE_STATUS = {
  uploading: ["Uploading", "text-slate-500"], processing: ["Reading…", "text-[#9a7322]"], ready: ["Read by AI", "text-emerald-700"],
  stored_only: ["Stored — not analysed", "text-slate-600"], failed: ["Couldn't read", "text-red-700"], rejected: ["Rejected", "text-red-700"],
};

export const ACCEPT = ".pdf,.docx,.xlsx,.pptx,.csv,.txt,.dxf,.dwg,.png,.jpg,.jpeg,.webp,.doc,.xls,.ppt,.zip";
